import {Form, Formik} from 'formik';
import {useTranslation} from 'next-i18next';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import TextLocal from '@/src/textLocal/containers/TextLocal';

import {Button, Input, Separator, Text} from '../../../ui';
import css from '../styles/EditFullNamePopupLayout.module.css';

const MAX_TEXT_INPUT_LENGTH = 30;

const getValidationSchema = (t) => {
  return Yup.object().shape({
    first_name: Yup.string()
      .min(2, t('validation.min-length-error', {minLength: 2}))
      .max(50, t('validation.max-length-error', {maxLength: 50}))
      .required(t('validation.field-req')),
    last_name: Yup.string()
      .min(2, t('validation.min-length-error', {minLength: 2}))
      .max(50, t('validation.max-length-error', {maxLength: 50}))
      .required(t('validation.field-req')),
  });
};

const EditFullNamePopupLayout = ({
  firstName,
  lastName,
  onSubmitClick,
  onCancelClick,
  isLoading,
}) => {
  const {t} = useTranslation('common');

  return (
    <div className={css.popup}>
      <div className={css.heading}>
        <Text
          fontSize={Text.FONT_SIZE.SIZE_32}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
          fontFamily={Text.FONT_FAMILY.RUBIK}
        >
          <TextLocal id={'profile.edit-name'} />
        </Text>
      </div>
      <Formik
        initialValues={{first_name: firstName, last_name: lastName}}
        onSubmit={onSubmitClick}
        validationSchema={getValidationSchema(t)}
      >
        <Form>
          <div>
            <div className={css.formFields}>
              {/*@ts-ignore*/}
              <Input
                width={Input.WIDTH.WIDTH_FULL}
                name={'first_name'}
                placeholder={t('emailStep.first_name')}
                maxLength={MAX_TEXT_INPUT_LENGTH}
              />
              {/*@ts-ignore*/}
              <Input
                placeholder={t('emailStep.last_name')}
                width={Input.WIDTH.WIDTH_FULL}
                name={'last_name'}
                maxLength={MAX_TEXT_INPUT_LENGTH}
              />
            </div>
            <Separator borderWeight={Separator.BORDER_WEIGHT.THIN} />
            <div className={css.buttonsBlock}>
              <div className={css.cancelPseudoButton} onClick={onCancelClick}>
                <Text
                  color={Text.COLOR.GREY}
                  fontWeight={Text.FONT_WEIGHT.MEDIUM}
                  fontSize={Text.FONT_SIZE.SIZE_16}
                >
                  <TextLocal id={'create-course.cancel'} />
                </Text>
              </div>
              <Button
                color={Button.COLOR.PRIMARY}
                height={Button.HEIGHT.REGULAR}
                type={Button.TYPES.SUBMIT}
                isLoading={isLoading}
              >
                <TextLocal id={'profile.save'} />
              </Button>
            </div>
          </div>
        </Form>
      </Formik>
    </div>
  );
};

EditFullNamePopupLayout.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  onSubmitClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default EditFullNamePopupLayout;
